import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { ElementSelector } from "../../../library-js/dom-tools/ElementSelector";
import { OnChange, OnClick, OnInput, OnKeyUp } from "../../../library-js/dom-tools/EventListeners";
import { URLHash } from "../../../library-js/dom/URLHash";
import { RegexValidator } from "../../../library-js/validators/RegexValidator";
import { EmailValidator } from "../../../library-js/validators/EmailValidator";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { Rokojori } from "../Rokojori";
import { UserSignUpRequest } from "../../../library-js/php/user/UserSignUpRequest";
import { UserAccountCreationInput, UserCreateAccountRequest } from "../../../library-js/php/user/UserCreateAccountRequest";
import { UserAccountBlock } from "./UserAccountBlock";
import { Overlay } from "../overlay/Overlay";

export class ProfileUI
{
  static readonly attribute = new ElementAttribute( "profile" );
  static readonly selector = new ElementSelector( UserAccountBlock.type, ProfileUI.attribute );

  static applyOnDocument()
  {
    ProfileUI.selector.forAllInDoc( e => ProfileUI.applyOnElement( e ) );
  }  

  static applyOnElement( e:HTMLElement )
  {
    ClassFlag.hidden.removeFrom( UserAccountBlock.inputBlock.query( e ) );
  }

}